import React from "react";
import styles from "./styles/spinner.module.scss";

export const Spinner = () => <div className={`${styles.spinner}`}></div>;
